const state = {
  id: undefined,
  ad_hoc: false,
  checklist_template_id: undefined,
  completed: false,
  debtor_type: undefined,
  debtor_id: undefined,
  due_date: '',
  hidden: false,
  notification_emails: [],
  notification_frequency: '',
  owner_id: undefined,
  owner_type: '',
  subject_id: undefined,
  subject_type: '',
  task_list_template_id: undefined,
  template_checklist: false,
  template_project: true,
  template_version: '',
  title: '',
  user_id: undefined,
  workflow: false,
}

export const requiredFields = [
  { key: 'title' },
]

export default state
